import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetVerifyAccountCountsQuery } from '../app/api';
import { useGetAllMemberStatsQuery, useGetStudioCountsQuery } from '../app/api';
import PropTypes from "prop-types";
import {Row, Col, Card, ProgressBar} from 'react-bootstrap';

export default function Dashboard(){
  const {data: accountsCount} = useGetVerifyAccountCountsQuery();
  const {data: membersCountData} = useGetAllMemberStatsQuery();
  const {data: studioCounts} = useGetStudioCountsQuery();
 
  const [studioActiveTotal, setStudioActiveTotal] = useState(0);
  const [studioTotal, setStudioTotal] = useState(0);
  const [studioApprovedTotal, setStudioApprovedTotal] = useState(0);
  const [studioDeniedTotal, setStudioDeniedTotal] = useState(0);
  const [affiliateTotal, setAffiliateTotal] = useState(0);
  const [affiliateApprovedTotal, setAffiliateApprovedTotal] = useState(0);
  const [affiliateDeniedTotal, setAffiliateDeniedTotal] = useState(0);
  const [memberTotal, setMemberTotal] = useState(0);


  useEffect(() => {
    if (studioCounts) {
      const sum = studioCounts.reduce((acc, item) => acc + item[1], 0);
      setStudioActiveTotal(sum);
    }
  }, [studioCounts])

  useEffect(() => {
    if (membersCountData) {
      const total = membersCountData.reduce((sum, item) => sum + item['count'], 0);
      setMemberTotal(total);
    }

  }, [membersCountData])
  useEffect(() => {
    if (accountsCount) {
      setStudioTotal(accountsCount.find(t => t.account_type == 'studio' &&  t.status == 'PENDING')?.count || 0);
      setStudioApprovedTotal(accountsCount.find(t => t.account_type == 'studio' &&  t.status == 'APPROVED')?.count || 0);
      setStudioDeniedTotal(accountsCount.find(t => t.account_type == 'studio' &&  t.status == 'DENIED')?.count || 0 );
      setAffiliateTotal(accountsCount.find(t => t.account_type == 'global_partner' &&  t.status == 'PENDING')?.count || 0);
      setAffiliateApprovedTotal(accountsCount.find(t => t.account_type == 'global_partner' &&  t.status == 'APPROVED')?.count || 0);
      setAffiliateDeniedTotal(accountsCount.find(t => t.account_type == 'global_partner' &&  t.status == 'DENIED')?.count || 0);
    }

  }, [accountsCount])

  // Mock data
  const summaryData = {
    affiliates: {
      total: affiliateTotal, 
      pending: affiliateTotal,
      approved: affiliateApprovedTotal,
      rejected: affiliateDeniedTotal
    },
    studios: {
      total: studioTotal,
      pending: studioTotal,
      approved: studioApprovedTotal,
      rejected: studioDeniedTotal 
    },
    customers: {
      total: memberTotal,
      pending: 0,
      approved: 0,
      rejected: 0 
    }
  };

  const StatusCard = ({ title, icon, data, iconColor }) => {
    const navigate = useNavigate();
    return (
      <div className="card h-100">
        <div className="card-body">
          <div className="d-flex justify-content-between mb-3">
            <h6 className="card-title mb-0">{title}</h6>
            <i className={`bi bi-${icon} text-${iconColor}`}></i>
          </div>
          <h2 className="mb-3">{data.total.toLocaleString()}</h2>
          <div className="row text-center">
            <div className="col">
              <div className="small text-muted">Pending</div>
              <div className="fw-bold">{data.pending}</div>
            </div>
            <div className="col">
              <div className="small text-muted">Approved</div>
              <div className="fw-bold">{data.approved}</div>
            </div>
            <div className="col">
              <div className="small text-muted">Rejected</div>
              <div className="fw-bold">{data.rejected}</div>
            </div>
          </div>
          <button className="btn btn-outline-primary w-100 mt-3" onClick={()=>{title == 'Affiliates' ? navigate('/admin') : navigate('/studios')}}>
            View All {title}
          </button>
        </div>
      </div>
    )
  };
  StatusCard.propTypes = {
    title: PropTypes.string,
    icon: PropTypes.string,
    data: PropTypes.object,
    iconColor: PropTypes.string,
  }

  const CircularProgress = ({ percentage, variant }) => {
    const circumference = 2 * Math.PI * 40; // radius = 40
    const strokeDashoffset = circumference - (percentage / 100) * circumference;
    const variantColors = {
      danger: '#dc3545',
      warning: '#ffc107',
      success: '#28a745'
    };

    return (
      <div className="position-relative mx-auto" style={{ width: '120px', height: '120px' }}>
        <svg className="w-100 h-100" style={{ transform: 'rotate(-90deg)' }}>
          <circle
            cx="60"
            cy="60"
            r="40"
            stroke="#e9ecef"
            strokeWidth="8"
            fill="none"
          />
          <circle
            cx="60"
            cy="60"
            r="40"
            stroke={variantColors[variant]}
            strokeWidth="8"
            fill="none"
            style={{
              strokeDasharray: circumference,
              strokeDashoffset,
              transition: 'stroke-dashoffset 0.3s'
            }}
          />
        </svg>
        <div 
          className="position-absolute top-50 start-50 translate-middle text-center"
          style={{ fontSize: '1.25rem', fontWeight: 'bold' }}
        >
          {percentage}%
        </div>
      </div>
    );
  };
  CircularProgress.propTypes = {
    percentage: PropTypes.number,
    variant: PropTypes.string,
  }

  const ActivityItem = ({ icon, color, title, time, actionLabel }) => (
    <div className="activity-item d-flex align-items-center p-3 rounded">
      <div className={`bg-${color} bg-opacity-10 p-2 rounded-circle me-3`}>
        <i className={`bi bi-${icon} text-${color}`}></i>
      </div>
      <div className="flex-grow-1">
        <div className="fw-medium">{title}</div>
        <small className="text-muted">{time}</small>
      </div>
      <button className="btn btn-sm btn-light">{actionLabel}</button>
    </div>
  );
  ActivityItem.propTypes = {
    icon: PropTypes.string,
    color: PropTypes.string,
    title: PropTypes.string,
    time: PropTypes.string,
    actionLabel: PropTypes.string,
  }

  return (
   
        <div className="container-fluid mt-4">
          <div className="row g-4 mb-4">
            <div className="col-md-4">
              <StatusCard
                title="Affiliates"
                icon="people"
                data={summaryData.affiliates}
                iconColor="primary"
              />
            </div>
            <div className="col-md-4">
              <StatusCard
                title="Studios"
                icon="film"
                data={summaryData.studios}
                iconColor="purple"
              />
            </div>
            <div className="col-md-4">
              <StatusCard
                title="Members"
                icon="person-check"
                data={summaryData.customers}
                iconColor="success"
              />
            </div>
          </div>

          <div className='idenfy'>
          <Row className="g-4 mb-4">
            <Col>
              <Card className="h-100">
                <Card.Header>
                  <Card.Title>Studio KYC Status</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col>
                      <div className="text-center mb-4">
                        <CircularProgress 
                          percentage={studioActiveTotal ? ((studioCounts?.find(t=>t[0] === 1)[1] * 100)/studioActiveTotal).toFixed(2) : 0}
                          variant={'success'}
                        />
                        <p>Complete</p>
                      </div>
                    </Col>
                    <Col>
                      <div className="text-center mb-4">
                        <CircularProgress 
                          percentage={studioActiveTotal ? (((studioCounts?.find(t=>t[0] === 3)||[0,0])[1] * 100)/studioActiveTotal).toFixed(2) : 0}
                          variant={'warning'}
                        />
                        <p>Denied</p>
                      </div>
                    </Col>
                    <Col>
                      <div className="text-center mb-4">
                        <CircularProgress 
                          percentage={studioActiveTotal ? (((((studioCounts?.find(t=>t[0] === 4)||[0,0])[1]) + ((studioCounts?.find(t=>t[0] === 5)||[0,0])[1])) * 100)/studioActiveTotal).toFixed(2) : 0}
                          variant={'danger'}
                        />
                        <p>Blocked</p>
                      </div>
                    </Col>
                    <Col>
                      <div className="text-center mb-4">
                        <CircularProgress 
                          percentage={studioActiveTotal ? (((studioCounts?.find(t=>t[0] === 6)||[0,0])[1] * 100)/studioActiveTotal).toFixed(2) : 0}
                          variant={'success'}
                        />
                        <p>Pending</p>
                      </div>
                    </Col>
                    <Col>
                      <div className="text-center mb-4">
                        <CircularProgress 
                          percentage={studioActiveTotal ? (((studioCounts?.find(t=>t[0] === 0)||[0,0])[1] * 100)/studioActiveTotal).toFixed(2) : 0}
                          variant={'success'}
                        />
                        <p>No Attempt</p>
                      </div>
                    </Col>
                  </Row>
                  <div>
                    <div className="mb-3">
                      <div className="d-flex justify-content-between mb-1">
                        <small>Completed</small>
                        <small>{(studioCounts?.find(t=>t[0]===1)||[0,0])[1]}/{studioActiveTotal}</small>
                      </div>
                      <ProgressBar
                        now={studioActiveTotal ? (((studioCounts?.find(t=>t[0] === 1)||[0,0])[1] * 100)/studioActiveTotal).toFixed(2) : 0}
                        variant={100}
                      />
                    </div>
                    <div className="mb-3">
                      <div className="d-flex justify-content-between mb-1">
                        <small>Denied</small>
                        <small>{(studioCounts?.find(t=>t[0]===3)||[0,0])[1]}/{studioActiveTotal}</small>
                      </div>
                      <ProgressBar
                        now={studioActiveTotal ? (((studioCounts?.find(t=>t[0] === 3)||[0,0])[1] * 100)/studioActiveTotal).toFixed(2) : 0}
                        variant={100}
                      />
                    </div>
                    <div className="mb-3">
                      <div className="d-flex justify-content-between mb-1">
                        <small>Blocked</small>
                        <small>{(studioCounts?.find(t=>t[0]===4)||[0,0])[1]+(studioCounts?.find(t=>t[0]===5)||[0,0])[1]}/{studioActiveTotal}</small>
                      </div>
                      <ProgressBar
                        now={studioActiveTotal ? (((((studioCounts?.find(t=>t[0] === 4)||[0,0])[1]) + ((studioCounts?.find(t=>t[0] === 5)||[0,0])[1])) * 100)/studioActiveTotal).toFixed(2) : 0}
                        variant={100}
                      />
                    </div>
                    <div className="mb-3">
                      <div className="d-flex justify-content-between mb-1">
                        <small>Pending</small>
                        <small>{(studioCounts?.find(t=>t[0]===6)||[0,0])[1]}/{studioActiveTotal}</small>
                      </div>
                      <ProgressBar
                        now={studioActiveTotal ? (((studioCounts?.find(t=>t[0] === 6)||[0,0])[1] * 100)/studioActiveTotal).toFixed(2) : 0}
                        variant={100}
                      />
                    </div>
                    <div className="mb-3">
                      <div className="d-flex justify-content-between mb-1">
                        <small>No Attempt</small>
                        <small>{(studioCounts?.find(t=>t[0]===0)||[0,0])[1]}/{studioActiveTotal}</small>
                      </div>
                      <ProgressBar
                        now={studioActiveTotal ? (((studioCounts?.find(t=>t[0] === 0)||[0,0])[1] * 100)/studioActiveTotal).toFixed(2) : 0}
                        variant={100}
                      />
                    </div>
                  </div>
                  <div className="text-center mt-3 hidden">
                    <strong>
                      2 / 30 tasks completed
                    </strong>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          </div>

          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">Recent Activity</h5>
            </div>
            <div className="card-body">
              <ActivityItem
                icon="people"
                color="primary"
                title="Audit Trail Information Here"
                time="1 hr ago"
                actionLabel="Review"
              />
              <ActivityItem
                icon="people"
                color="primary"
                title="Audit Trail Information Here"
                time="8 hrs ago"
                actionLabel="Review"
              />
              <ActivityItem
                icon="film"
                color="purple"
                title="Audit Trail Information Here"
                time="1 day ago"
                actionLabel="View"
              />
            </div>
          </div>
    </div>
  );
};
